import React, { useState, useEffect, useRef } from "react";
import { useSnackbar } from "notistack";
// import { FaTrash } from "react-icons/fa";
import { MdSearch } from "react-icons/md";
import ConfirmationModal from "../../components/common/confirm/ConfirmationModal";
import AdminLoader from "../../components/common/loader/AdminLoader";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { deleteLead, fetchLeads, updateLead } from './../../store/slices/leadsSlice';
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useLoggedUser } from "../../utils/useLoggedUser";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { SquarePen, Trash2, EllipsisVertical } from "lucide-react";
import { deleteClientDetails } from "../../store/slices/ClientMaster/clientMasterSlice";
import { resolveCountryInputConfig } from "../../utils/currencyUtils";
import { getFeatureAccessLevel } from '../../utils/featureAccessUtils';

const ClientMaster = () => {

  const dispatch = useDispatch();
  const loggedUser = useLoggedUser();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Client Master"));
  }, [dispatch]);

  // const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [, setShowGroupDropdown] = useState(false);
  // const [showGroupDropdown, setShowGroupDropdown] = useState(false);

  const [isLoading, SetisLoading] = useState(false);

  const [showLogout, setshowlogout] = useState(false);
  const popupRef = useRef(null);
  // const name = localStorage.getItem("name");

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);

  const [LeadReports, setLeadReports] = useState([]);
  const [, setGroupNames] = useState([]);
  // const [GroupNames, setGroupNames] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredLeadReports, setFilteredLeadReports] = useState([]);

  const { leads } = useSelector((state) => state.leads);
  const { group } = useSelector((state) => state.group);
  const { employees } = useSelector((state) => state.employees);

  const emailForAccess = typeof localStorage !== "undefined" ? localStorage.getItem("email") : "";
  const currentEmployee = employees?.find((emp) => emp.EmpEmail === emailForAccess) ?? null;
  const hasNoFeatureConfig = !currentEmployee || !Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0;
  const clientMasterAccessLevel = getFeatureAccessLevel(currentEmployee, "CLIENT MASTER EDIT CLIENT DATA");
  const isViewOnly = !!currentEmployee && !hasNoFeatureConfig &&
    (clientMasterAccessLevel && String(clientMasterAccessLevel).trim().toUpperCase() === "VIEW ONLY");

  const dropdownsRef = useRef(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If dropdown is open and click is outside the dropdown AND not on the dropdown icon
      if (openDropdownId && dropdownsRef.current && !dropdownsRef.current.contains(event.target)) {
        // Also check if the click was on the ellipsis icon itself
        const clickedElement = event.target;
        const isEllipsisIcon = clickedElement.closest('.dropdown-toggle-icon');

        if (!isEllipsisIcon) {
          setOpenDropdownId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId]);

  useEffect(() => {
    dispatch(fetchLeads())
  }, [dispatch])

  useEffect(() => {
    setGroupNames(group);
  }, [group]);

  useEffect(() => {
    setLeadReports(leads);
  }, [leads]);

  // Add sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc' // 'asc' or 'desc'
  });

  // Sorting function
  const sortAlphabetically = (key, direction) => {
    setSortConfig({ key, direction });
  };

  // Apply sorting to filtered data
  useEffect(() => {
    if (sortConfig.key) {
      const sortedData = [...filteredLeadReports].sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        // Handle null/undefined values
        if (aValue === null || aValue === undefined) aValue = '';
        if (bValue === null || bValue === undefined) bValue = '';

        // Convert to string for consistent comparison
        aValue = aValue.toString().toLowerCase();
        bValue = bValue.toString().toLowerCase();

        if (sortConfig.direction === 'asc') {
          return aValue.localeCompare(bValue);
        } else {
          return bValue.localeCompare(aValue);
        }
      });

      setFilteredLeadReports(sortedData);
    }
  }, [sortConfig, filteredLeadReports]); // Re-sort when sortConfig changes

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterLeadReports(query);
    setCurrentPage(1);
    // Reset sorting when search changes
    setSortConfig({ key: null, direction: 'asc' });
  };

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim(); // Normalize query
    if (!query.trim()) {
      setFilteredLeadReports(LeadReports); // Restore original data
      return;
    }

    const filtered = LeadReports.filter((LeadReport) =>
      Object.entries(LeadReport).some(([key, value]) => {
        if (
          key === "comments" ||
          key === "Reference" ||
          key === "QuotedValue" ||
          key === "Status" ||
          key === "FollowupDate" ||
          key === "TypeService" ||
          key === "Probability" ||
          key === "Source" ||
          key === "LeadType" ||
          key === "LeadOwner" ||
          key === "LeadOwnerEmail" ||
          key === "LeadDate"
        )
          return false;
        if (value !== null && value !== undefined) {
          let formattedValue = value.toString().trim().toLowerCase(); // Trim spaces & normalize
          return formattedValue.includes(lowerCaseQuery);
        }
        return false;
      })
    );

    setFilteredLeadReports(filtered);
  };

  const [ClientName, setClientName] = useState("");
  const [AssignedGroup, setAssignedGroup] = useState("");
  const [ProjectName, setProjectName] = useState("");
  const [ClientPhone, setClientPhone] = useState("");
  const [ClientContactName, setClientContactName] = useState("");
  const [ClientEmail, setClientEmail] = useState("");
  const [Status, setStatus] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [, setEditid] = useState("");
  console.log("ClientPhone", ClientPhone)
  const [editingLeadReport, setEditingLeadReport] = useState(null);
  console.log("ClientPhone editingLeadReport", editingLeadReport)

  const editLeadReport = (id) => {
    if (isViewOnly) return;
    const ReportToEdit = LeadReports.find((LeadReport) => LeadReport.id === id);
    setEditingLeadReport(ReportToEdit);
    setShowEdit(true);
    setShowTable(false)
    setEditid(id);
  };

  useEffect(() => {
    if (editingLeadReport) {
      setClientName(editingLeadReport.ClientName);
      setClientContactName(editingLeadReport.ClientContactName);
      // setClientPhone(editingLeadReport.ClientPhone);
      setClientEmail(editingLeadReport.ClientEmail);
      setProjectName(editingLeadReport.ProjectName);
      setAssignedGroup(editingLeadReport.AssignedGroup);
      setStatus(editingLeadReport.Status);

      let phone = editingLeadReport.ClientPhone;

      if (phone === null || phone === undefined) {
        phone = "";
      } else if (typeof phone === "object") {
        // if backend sends object
        phone = phone.phone || "";
      }

      phone = phone.toString().replace(/\D/g, "");

      // ✅ ensure country code exists
      if (loggedUser?.countrycode === "+91" && phone && !phone.startsWith("91")) {
        phone = "91" + phone;
      }

      if (loggedUser?.countrycode === "+1" && phone && !phone.startsWith("1")) {
        phone = "1" + phone;
      }

      setClientPhone(phone);
    }
  }, [editingLeadReport, loggedUser]);


  const Submit = async (e) => {
    e.preventDefault();
    if (isViewOnly) return;

    if (
      !ClientName ||
      !AssignedGroup ||
      !ClientPhone ||
      !ClientContactName ||
      !Status ||
      !ProjectName
    ) {
      enqueueSnackbar("Please fill all the fields!", { variant: "error" });
      return;
    }
    const updatedLeadData = {
      ProjectName: ProjectName,
      ClientName,
      ClientEmail,
      ClientContactName,
      AssignedGroup,
      ClientPhone,
    }
    
    console.log("Updating client - ProjectName:", ProjectName);
    console.log("Updated data:", updatedLeadData);
    
    SetisLoading(true);
    try {
      // Update the lead record (this includes ProjectName and all client fields)
      await dispatch(updateLead({
        id: editingLeadReport.id,
        updatedData: updatedLeadData
      })).unwrap()

      enqueueSnackbar("Client edited Successfully.", {
        variant: "success",
      });
      dispatch(fetchLeads())
      // Reset form fields
      setClientName("");
      setClientPhone("");
      setClientContactName("");
      setStatus("");
      setClientEmail("");
      setProjectName("");
      setAssignedGroup("");
      setShowEdit(false);
      setShowTable(true)
    } catch (error) {
      console.error("Error updating client - Full error object:", error);
      console.error("Error type:", typeof error);
      console.error("Error keys:", Object.keys(error || {}));
      
      // Extract error message from different possible error structures
      let errorMessage = "Failed to update client details!";
      
      // Check various error structures
      if (typeof error === 'string') {
        errorMessage = error;
      } else if (error?.error) {
        errorMessage = typeof error.error === 'string' ? error.error : JSON.stringify(error.error);
      } else if (error?.message) {
        errorMessage = error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error?.payload?.error) {
        errorMessage = error.payload.error;
      } else if (error?.payload?.message) {
        errorMessage = error.payload.message;
      } else if (typeof error === 'object' && error !== null) {
        // Try to stringify the error object to see what's in it
        try {
          const errorStr = JSON.stringify(error);
          if (errorStr !== '{}') {
            errorMessage = errorStr;
          }
        } catch (e) {
          errorMessage = "Unknown error occurred";
        }
      }
      
      console.error("Extracted error message:", errorMessage);
      enqueueSnackbar(errorMessage, {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
  };

  const Cancel = (e) => {
    e.preventDefault();

    e.preventDefault();
    setClientName("");
    setClientEmail("");
    setClientPhone("");
    setClientContactName("");
    setStatus("");
    setProjectName("");
    setAssignedGroup("");
    setShowEdit(false);
    setShowTable(true)
  };

  const deleteLeadReport = async (id) => {
    if (isViewOnly) return;
    try {
      await dispatch(deleteLead(id)).unwrap(); // Dispatch Redux action

      enqueueSnackbar("Client deleted successfully!", { variant: "success" });
      dispatch(fetchLeads())
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error || "Failed to delete client!", {
        variant: "error",
      });
    }
  };

  const handleDelete = (leadId) => {
    dispatch(deleteClientDetails(leadId));
  };



  useEffect(() => {
    setFilteredLeadReports(LeadReports);
  }, [LeadReports]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sourceToDelete, setsourceToDelete] = useState(null);

  const openDeleteModal = (id) => {
    if (isViewOnly) return;
    setsourceToDelete(id);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setsourceToDelete(null);
  };

  const confirmDelete = async () => {
    if (sourceToDelete) {
      await deleteLeadReport(sourceToDelete); // Call your existing delete function
      await handleDelete(sourceToDelete); // Call your existing delete function
    }
    closeDeleteModal();
  };
  const dropdownRefGroup = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setShowGroupDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleInputChange = (group) => {
  //   setAssignedGroup(group);
  // };

  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage] = useState(10);
  const totalItems = filteredLeadReports.length;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;

  // Function to calculate the number of pages
  const totalPages = Math.ceil(filteredLeadReports.length / itemsPerPage);

  // Get sorted data for current page
  const currentData = filteredLeadReports.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  console.log("currentData", currentData)

  const { iso2: defaultCountry, onlyCountries: allowedCountries } =
    resolveCountryInputConfig({
      countrycode: loggedUser?.countrycode,
      region: loggedUser?.region,
    });

  return (
    <>
      <div className=" bg-[#f3f8f8] pb-6 h-full">
        <ConfirmationModal
          isOpen={isModalOpen}
          onClose={closeDeleteModal}
          onConfirm={confirmDelete}
        />


        {isLoading ? (
          <AdminLoader isLoading={isLoading} />
        ) : (
          <>
            {showEdit && (
              <div className=" p-4 bg-white mb-16  border rounded-md border-gray-200 relative  shadow-lg justify-center top-4">
                <h1 className="text-xl mb-2 font-semibold">
                  Edit Client Details
                </h1>
                <hr />
                <hr />
                <br />
                <div className="flex justify-start w-full">
                  <div className="mx-3 w-full">
                    <label className="block" htmlFor="Name">
                      Client Name
                    </label>
                    <input
                      className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                      type="text"
                      placeholder="Enter Name"
                      value={ClientName}
                      onChange={(e) => setClientName(e.target.value)}
                    />
                  </div>
                  <div className="mx-3 w-full">
                    <label className="block" htmlFor="Name">
                      Project Name
                    </label>
                    <input
                      className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                      type="text"
                      placeholder="Enter Project Name"
                      value={ProjectName}
                      onChange={(e) => setProjectName(e.target.value)}
                    />
                  </div>
                  <div className="mx-3 w-full">
                    <label className="block" htmlFor="Name">
                      Client Contact Person Name
                    </label>
                    <input
                      className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                      type="text"
                      placeholder="Enter Name"
                      value={ClientContactName}
                      onChange={(e) => setClientContactName(e.target.value)}
                    />
                  </div>
                </div>
                <br />
                <div className="flex justify-start w-full">
                  <div className="mx-3 w-full">
                    <label className="block" htmlFor="email">
                      Email ID
                    </label>
                    <input
                      className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                      type="text"
                      placeholder="Enter Email ID"
                      value={ClientEmail}
                      onChange={(e) => setClientEmail(e.target.value)}
                    />
                  </div>
                  <div className="mx-3 w-full">
                    <label className="block" htmlFor="email">
                      Phone No ccc
                    </label>
                    {/* <PhoneInput
                      country={defaultCountry}
                      value={ClientPhone}
                      disableDropdown={true}
                      countryCodeEditable={false}   // 🔴 THIS IS THE FIX
                      onChange={(value) => setClientPhone(value)}
                      onlyCountries={allowedCountries}
                      preferredCountries={[]}       // <-- Required to remove default countries
                      inputProps={{
                        required: true,
                        className:
                          "w-full h-10 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-10",
                        style: {
                          fontFamily:
                            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                        },
                      }}
                    /> */}

                    <PhoneInput
                      country={defaultCountry}
                      value={ClientPhone}
                      disableDropdown={true}
                      countryCodeEditable={false}   // 🔴 THIS IS THE FIX
                      onChange={(phone) => setClientPhone(phone)}
                      onlyCountries={allowedCountries}
                      preferredCountries={[]}       // <-- Required to remove default countries
                      enableSearch={true}           // optional
                      inputProps={{
                        required: true,
                        className:
                          "w-full border border-gray-400 lg:pl-12 cp:pl-4 outline-0 rounded overflow-hidden shadow-md h-10 p-2",
                        style: {
                          fontFamily:
                            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                        },
                      }}
                    />
                  </div>

                  <div className="mx-3 w-full">
                    {/* <label className="block" htmlFor="Name">
                      Group
                    </label>
                    <div className=" ">
                      <div
                        ref={dropdownRefGroup}
                        className="relative flex shadow-sm p-0 -pb-4 rounded-md border border-gray-400 align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className="absolute cursor-pointer right-2 m-auto bg-white"
                          onClick={() =>
                            setShowGroupDropdown(!showGroupDropdown)
                          }
                        />

                        <button
                          type="button"
                          onClick={() =>
                            setShowGroupDropdown(!showGroupDropdown)
                          }
                          className="border border-gray-300 text-left rounded-md shadow-md outline-none p-2 w-full pl-2"
                        >
                          {AssignedGroup ? AssignedGroup : <p>Select Group</p>}
                        </button>

                        {showGroupDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-gray-100 text-sm border border-gray-300 shadow-lg flex flex-col gap-2"
                          >
                            <div
                              className="p-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => handleInputChange("All")}
                            >
                              All
                            </div>
                            {GroupNames.map((group) => (
                              <div
                                className="p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={() =>
                                  handleInputChange(group.newGroupName)
                                }
                                key={group.id}
                                value={group.newGroupName}
                              >
                                {group.newGroupName}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div> */}
                  </div>
                </div>
                <br />
                <div className="flex mt-6 justify-start">
                  <button
                    onClick={Submit}
                    className="mx-2 py-2 px-5 bg-[#e32278] hover:bg-[#e12298] overflow-hidden shadow-md text-white rounded-md"
                  >
                    Update
                  </button>
                  <button
                    onClick={Cancel}
                    className="mx-2 py-2 px-5 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-md"
                  >
                    Cancel
                  </button>
                </div>
                <br />
              </div>
            )}
          </>
        )}

        <div className=" relative ">

          {showTable && (
            <>
              <div className="  bg-white border border-gray-200 relative w-full justify-center top-4 rounded-md">

                {/* <div className="flex bg-white p-2">
                  <h1 className="text-xl w-full  font-semibold">
                    All Clients{" "}
                  </h1>
                  <div className="relative flex w-64 justify-end">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      className="border  w-full border-gray-300 rounded-md mb-2 p-2 overflow-hidden shadow-md outline-none pl-4"
                      placeholder="Search"
                    />
                    <MdSearch
                      size={30}
                      className="mt-2 absolute right-1 top-3 transform -translate-y-1/2 text-gray-500"
                    />
                  </div>
                </div> */}

                <div className="flex justify-between align-middle items-center p-2">
                  <h1 className="text-xl font-semibold">All Clients</h1>
                  <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                    <MdSearch className=" w-5 h-5 text-gray-500" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      placeholder="Search"
                      className="bg-[#e0e7ff] outline-none w-[80%]"
                    />
                  </div>
                </div>

                <div className="max-h-[30rem] w-full overflow-auto">
                  <div className=" sticky top-0 w-full z-[100]">
                    <div className="bg-[#e8e8e8] flex font-semibold">
                      <div className="px-3  py-3 w-[6%] text-center border text-xs font-medium capitalize flex justify-center align-middle items-center flex-shrink-0 ">
                        Sr.No
                      </div>
                      <div className="px-2 py-1 w-[16%] border text-xs capitalize flex gap-1 justify-between align-middle items-center ">
                        <div className="">Client Name</div>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() => sortAlphabetically("ClientName", "asc")}
                          >
                            <ArrowDropUp
                              color={sortConfig.key === "ClientName" && sortConfig.direction === "asc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortAlphabetically("ClientName", "desc")}
                          >
                            <ArrowDropDown
                              color={sortConfig.key === "ClientName" && sortConfig.direction === "desc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="px-2 py-1 w-[18%]  border text-xs  capitalize flex gap-1 justify-between align-middle items-center">
                        <div className="w-[60%]">Project Name </div>
                        <div className="w-[40%] flex flex-col text-center">
                          <div
                            className="cursor-pointer "
                            onClick={() => sortAlphabetically("ProjectName", "asc")}
                          >
                            <ArrowDropUp
                              color={sortConfig.key === "ProjectName" && sortConfig.direction === "asc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortAlphabetically("ProjectName", "desc")}
                          >
                            <ArrowDropDown
                              color={sortConfig.key === "ProjectName" && sortConfig.direction === "desc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="px-2 py-1 w-[15%] relative border text-xs font-medium capitalize flex justify-between  align-middle items-center">
                        <div className="w-[80%] ">Contact Person
                        </div>
                        <div className="w-[20%] flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() => sortAlphabetically("ClientContactName", "asc")}
                          >
                            <ArrowDropUp
                              color={sortConfig.key === "ClientContactName" && sortConfig.direction === "asc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortAlphabetically("ClientContactName", "desc")}
                          >
                            <ArrowDropDown
                              color={sortConfig.key === "ClientContactName" && sortConfig.direction === "desc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="px-2 py-1 w-[18%] border text-xs  capitalize flex justify-between gap-1 align-middle items-center">
                        <div className="w-[70%] text-center"> Client Phone</div>
                        <div className="w-[30%] flex flex-col justify-center text-center">
                          <div
                            className="cursor-pointer "
                            onClick={() => sortAlphabetically("ClientPhone", "asc")}
                          >
                            <ArrowDropUp
                              color={sortConfig.key === "ClientPhone" && sortConfig.direction === "asc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortAlphabetically("ClientPhone", "desc")}
                          >
                            <ArrowDropDown
                              color={sortConfig.key === "ClientPhone" && sortConfig.direction === "desc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="px-2 py-2 w-[21%] border text-xs  capitalize flex gap-0 justify-between  align-middle items-center">
                        
                        <div className="w-[70%]">Client Email</div>
                        <div className="w-[30%] flex flex-col justify-start text-start">
                          <div
                            className="cursor-pointer "
                            onClick={() => sortAlphabetically("ClientEmail", "asc")}
                          >
                            <ArrowDropUp
                              color={sortConfig.key === "ClientEmail" && sortConfig.direction === "asc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortAlphabetically("ClientEmail", "desc")}
                          >
                            <ArrowDropDown
                              color={sortConfig.key === "ClientEmail" && sortConfig.direction === "desc" ? "#e32278" : "white"}
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="px-2 py-1 w-[5%] text-center border text-xs  capitalize flex justify-center  align-middle items-center flex-shrink-0">
                        Action
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    {currentData.length > 0 ? (
                      currentData?.map((LeadReport, index) => (
                        <div className="text-xs border-b flex " key={LeadReport.id}>
                          <div className="px-2 py-1 w-[6%] flex-shrink-0 text-center flex justify-center align-middle items-center">
                            {startIdx + index + 1}
                          </div>
                          <div className="px-2 py-1 w-[16%] break-all whitespace-normal flex-shrink-0 text-start flex align-middle items-center">
                            {LeadReport.ClientName}
                          </div>
                          <div className="px-2 py-1 w-[18%] break-all whitespace-normal  flex-shrink-0 text-start flex align-middle items-center">
                            {LeadReport.ProjectName}
                          </div>
                          <div className="px-2 py-1 w-[15%] break-all whitespace-normal text-start  flex-shrink-0 flex align-middle items-center">
                            {LeadReport.ClientContactName}
                          </div>
                          <div className="text-center py-1 w-[18%] break-all whitespace-normal flex-shrink-0 flex justify-center align-middle items-center">
                            +{String(LeadReport?.ClientPhone).replace(/^(\d{2})/, "$1 ")}
                          </div>
                          <div className="px-2 py-1 w-[21%] break-all whitespace-normal flex-shrink-0 text-start flex align-middle items-center">
                            {LeadReport.ClientEmail}
                          </div>
                          <div className="px-2 py-1 w-[5%]  flex-shrink-0 h cursor-pointer flex justify-center items-center  text-center"
                          >
                            <div className="px-2 relative">
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (isViewOnly) return;
                                  if (openDropdownId !== LeadReport.id) {
                                    setOpenDropdownId(LeadReport.id);
                                  } else {
                                    setOpenDropdownId(null);
                                  }
                                }}
                                className={`p-1 dropdown-toggle-icon ${isViewOnly ? "text-[#9ca3af] cursor-not-allowed pointer-events-none opacity-60" : "cursor-pointer"}`}
                              >
                                <EllipsisVertical />
                              </div>
                              {openDropdownId === LeadReport.id && (
                                <div
                                  ref={dropdownsRef}
                                  className={`z-[200] p-1 absolute flex flex-col ${index === currentData?.length - 1 ? 'bottom-full' : 'top-full'}  -left-5 bg-white rounded-md shadow border`}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div
                                    onClick={() => {
                                      if (isViewOnly) return;
                                      setOpenDropdownId(null);
                                      editLeadReport(LeadReport.id)
                                    }}
                                    className={`p-1 flex gap-1 w-full justify-start align-middle items-center border-b ${isViewOnly ? "text-[#9ca3af] cursor-not-allowed pointer-events-none opacity-60" : "cursor-pointer hover:bg-gray-50"}`}
                                  >
                                    <span title="Edit">
                                      <SquarePen size={15} className={isViewOnly ? "text-[#9ca3af]" : "text-blue-500"} />
                                    </span>
                                    Edit
                                  </div>
                                  <div
                                    onClick={() => {
                                      if (isViewOnly) return;
                                      setOpenDropdownId(null);
                                      openDeleteModal(LeadReport.id)
                                    }}
                                    className={`p-1 flex gap-1 w-full justify-start align-middle items-center ${isViewOnly ? "text-[#9ca3af] cursor-not-allowed pointer-events-none opacity-60" : "cursor-pointer hover:bg-gray-50"}`}
                                  >
                                    <span title="Delete">
                                      <Trash2 size={15} className={isViewOnly ? "text-[#9ca3af]" : "text-blue-500"} />
                                    </span>
                                    Delete
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        colSpan="6"
                        className="border p-4 text-start text-red-500"
                      >
                        {searchQuery
                          ? `No results found for "${searchQuery}"`
                          : "No results found"}
                      </div>
                    )}
                  </div>

                </div>

              </div>
              <div className="pt-2">
                {currentData.length > 0 && (
                  <div className="pagination p-3 flex justify-between items-center bg-white rounded-md pb-2">
                    <div>
                      {totalItems > 0 ? (
                        <>
                          Showing {startIdx + 1} to{" "}
                          {Math.min(endIdx, totalItems)} of {totalItems}{" "}
                          Entries
                        </>
                      ) : (
                        <>Showing 0 Entries</>
                      )}
                    </div>
                    {totalPages > 1 && (
                      <div>
                        <button
                          onClick={() => setCurrentPage(1)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === 1}
                          title="First Page"
                        >
                          <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === 1}
                        >
                          <ChevronRightIcon className="w-5 h-5 rotate-180" />

                          {/* Previous */}
                        </button>

                        {Array.from({ length: 3 }, (_, index) => {
                          // Calculate the page number for the current range
                          const pageNumber = currentPage - 1 + index;

                          // Ensure the pageNumber stays within bounds
                          if (
                            pageNumber >= 1 &&
                            pageNumber <= totalPages
                          ) {
                            return (
                              <button
                                key={pageNumber}
                                onClick={() => setCurrentPage(pageNumber)}
                                className={`px-2 py-2 mx-2 border rounded ${currentPage === pageNumber
                                  ? "bg-gray-300"
                                  : ""
                                  }`}
                              >
                                {pageNumber}
                              </button>
                            );
                          }

                          // Return null for out-of-bounds values
                          return null;
                        })}

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          className="p-2 border rounded"
                          disabled={currentPage === totalPages}
                        >
                          <ChevronRightIcon className="w-5 h-5" />
                          {/* Next */}
                        </button>
                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === totalPages}
                          title="Last Page"
                        >
                          <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </div>



        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    </>
  );
};

export default ClientMaster;